import React from 'react';

export const renderTextWithLinks = (text: string): React.ReactNode => {
	const urlRegex = /<([^>]+)>/g;
	const parts = text.split(urlRegex);
	return parts.map((part, index) =>
		part.includes('https') ? (
			<a
				key={index}
				href={part}
				target="_blank"
				rel="noopener noreferrer"
				className="cursor-pointer break-words text-blue-600 underline hover:text-blue-800"
			>
				{part}
			</a>
		) : (
			<span key={index} className="mt-6 text-wrap text-[20px] text-[#525252]">
				{part}
			</span>
		)
	);
};
